import axios from 'axios';

import AuthService from '@/services/auth/auth.service';

export default class HttpService {
	constructor() {
		this._baseUrl = process.env.VUE_APP_API_BASE;
		this._authService = new AuthService();
		this._setConfig();
	}

	_setConfig() {
		this._token = `Bearer ${this._authService.getToken()}`;
		this._url = this._baseUrl;
		this._axios = axios.create({
			baseURL: this._url,
			headers: {
				'Authorization': this._token,
			},
		});
	}

	get(path, query = []) {
		this._setConfig();
		return this._axios
			.get(path, {
				params: query,
			});
	}

	setAuthorization(token) {
		this._token = token;
		return this;
	}

	setBaseUrl(url) {
		this._url = url;
		return this;
	}

	delete(path) {
		this._setConfig();
		return this._axios
			.delete(path);
	}

	post(path, data) {
		this._setConfig();
		return this._axios
			.post(path, data);
	}

	put(path, data) {
		this._setConfig();
		return this._axios
			.put(path, data);
	}

	patch(path, data) {
		this._setConfig();
		return this._axios
			.patch(path, data);
	}
}
